// globals

const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})
//noScroll
class Member {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const body = document.querySelector("body")

    const modalBtns = document.querySelectorAll(".modal-toggle");
      modalBtns.forEach(function (btn) {
        btn.onclick = function () {
          const modal = btn.getAttribute('data-modal');
          document.getElementById(modal).classList.add("is-active")
          body.classList.add("is-fixed")
        };
      });
      const closeBtns = document.querySelectorAll(".modal-close");
      closeBtns.forEach(function (btn) {
        btn.onclick = function () {
          var modal = btn.closest('.modal');
          modal.classList.remove("is-active")
          body.classList.remove("is-fixed")
        };
      });


    /* 役員写真切り替え  */

    const executive = document.querySelectorAll(".js-executive-click")

    executive.forEach(el => {
      el.addEventListener("click", () => {
        const revContent = el.querySelector(".js-rev-content")        
        revContent.classList.toggle("is-rev")
      })
    })


  }
}

//noScroll
class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){


    const topBesideScroll = document.querySelector('.p-top__wrapper');
    const topBesideScroll02 = document.querySelector('.p-top__wrapper02');
    const body = document.querySelector("body")
    const topBesideEndPoint = document.querySelector(".js-endPoint").getBoundingClientRect().left
    const appearManPoint = document.querySelector(".js-FixedManStartPoint").getBoundingClientRect().right
    const disappearManPoint = document.querySelector(".js-FixedManEndPoint").getBoundingClientRect().right
    const storyFirstPoint = document.querySelector(".p-top__concept").getBoundingClientRect().right

    $(function(){
        /****************************
          横スクロール
         ****************************/
        if (window.matchMedia('(min-width: 768px)').matches) {
          /* ウィンドウサイズ669以上、767以下の処理を記述 */
          if(topBesideScroll) {
              gsap.registerPlugin(ScrollTrigger);
              const besideContents = gsap.utils.toArray('.js-besideContent');
              /**
              * 横スクロール開始
              */
              gsap.to( besideContents, {
                  x: -1 * (topBesideEndPoint) , // transformX
                  ease: "none", // easingの設定
                  scrollTrigger: { // scrollTrigger
                      trigger: topBesideScroll, // アニメーションの対象となる要素
                      pin: true, // 要素を固定する
                      scrub: 1, // スクロールとアニメーションを同期させる。数値で秒数の設定に
                      end: () => "+=" + topBesideEndPoint, // アニメーションの終了タイミング
                      invalidateOnRefresh: true,
                  }
              })
          }

          /****************************
          男性出現
          ****************************/
          if(topBesideScroll02) {
              gsap.registerPlugin(ScrollTrigger);
              const besideContents = gsap.utils.toArray('.js-besideContent02');
              /**
              * 横スクロール開始
              */
              gsap.to( besideContents, {
                  x: 1 * (disappearManPoint - appearManPoint) ,
                  ease: "none",
                  scrollTrigger: {
                      trigger: topBesideScroll02,
                      scrub: 1,
                      start: appearManPoint,
                      end:  disappearManPoint,
                      invalidateOnRefresh: true,

                  }
              })
          }

          const isHiddenFixedMan = document.querySelector(".js-besideContent02__inner")

          window.addEventListener("scroll", () => {


            if( window.scrollY > disappearManPoint){
              isHiddenFixedMan.classList.add("is-hidden")
            }else{
              isHiddenFixedMan.classList.remove("is-hidden")
            }
          })

          /****************************
          スクロール数パーセント表示
          ****************************/
          const percentBorder= document.querySelector(".js-scrollBorder")
          window.addEventListener("scroll", () => {
            let scrollY = window.scrollY;

            let scrollPercent = Math.floor(scrollY / topBesideEndPoint * 100);

            if(scrollY === 0){
              percentBorder.style.width = "0vw"
            }else{
              percentBorder.style.width = `${scrollPercent + 1}vw`
            }

          })

          /****************************
          フッター表示
          ****************************/
          const footer = document.querySelector(".footer-top")

          window.addEventListener("scroll", () => {
            let scrollY = window.scrollY;

            if(scrollY >= topBesideEndPoint - 1){
              footer.classList.add("is-active")
            }else{
              footer.classList.remove("is-active")
            }
          })


          /****************************
          ストーリーホバーアニメーション
          ****************************/
            const hovItems = document.querySelectorAll(".life-content")
            const handsdownMan = document.querySelector(".hands-down")
            const handsupMan = document.querySelector(".hands-up")
            const fixedManComment = document.querySelector(".js-fixedmanComment")
            const fixedManCommentText = document.querySelector(".js-fixedmanCommentText")
            hovItems.forEach((hovItem,i) => {
              const hovText = hovItem.querySelector(".js-point-hov");
              hovItem.addEventListener("mouseover", () => {
                handsdownMan.classList.add("is-hidden")
                handsupMan.classList.remove("is-hidden")

                switch (i){
                  case 0:
                    fixedManCommentText.innerHTML = "子どもに向けた金融教育についてお話します。"
                    break;
                  case 1:
                    fixedManCommentText.innerHTML = "中高生に向けた金融教育についてお話します。"
                    break;
                  case 2:
                    fixedManCommentText.innerHTML = "新社会人に向けたライフプランについてお話します。"
                    break;
                  case 3:
                    fixedManCommentText.innerHTML = "おふたりに合わせたライフプランについてお話します。"
                    break;
                  case 4:
                    fixedManCommentText.innerHTML = "お子様のご誕生に合わせたライフプランについてお話します。"
                    break;
                  case 5:
                    fixedManCommentText.innerHTML = "マイホーム購入に必要な資金計画についてお話します。"
                    break;
                  case 6:
                    fixedManCommentText.innerHTML = "社員向けの金融セミナーについてお話します。"
                    break;
                  case 7:
                    fixedManCommentText.innerHTML = "老後に向けた準備についてお話します。"
                    break;
                  case 8:
                    fixedManCommentText.innerHTML = "資産の継承についてお話します。"
                    break;
                  default:
                    console.log('error');
                }

                fixedManComment.classList.remove("is-hidden")
                hovText.textContent = "CHECK"


              })
              hovItem.addEventListener("mouseleave", () => {
                handsdownMan.classList.remove("is-hidden")
                handsupMan.classList.add("is-hidden")
                fixedManComment.classList.add("is-hidden")
              })
            })
      }})


      $(function(){
        if (window.matchMedia('(max-width: 767px)').matches) {
          /****************************
          SP storyスライダー
          ****************************/
          const swiper = new Swiper(".story-swiper", {
            slidesPerView: 1,
            spaceBetween: 50,
            speed: 800,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            },
            pagination: {
              el: ".swiper-pagination",
              type: "fraction",
            },
            allowTouchMove: false,

          });


          /****************************
          SP 吹き出しテキスト調整
          ****************************/
          const commentSP = document.querySelector(".js-sp-comment")
          const target = document.querySelector(".js-slide-itemWrap")
          const targetChildren = document.querySelector(".js-slide-itemWrap").children

          const options = {
            childList: true, //直接の子の変更を監視
            characterData: true,　 //文字の変化を監視
            characterDataOldValue: true,　//属性の変化前を記録
            attributes: true,　 //属性の変化を監視
            subtree: true, //全ての子要素を監視
        }
          const eachItems = () => {

            switch (true){
              case targetChildren[0].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "子どもに向けた金融教育についてお話します。"
                break;
              case targetChildren[1].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "中高生に向けた金融教育についてお話します。"
                break;
              case targetChildren[2].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "新社会人に向けたライフプランについてお話します。"
                break;
              case targetChildren[3].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "おふたりに合わせたライフプランについてお話します。"
                break;
              case targetChildren[4].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "お子様のご誕生に合わせたライフプランについてお話します。"
                break;
              case targetChildren[5].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "マイホーム購入に必要な資金計画についてお話します。"
                break;
              case targetChildren[6].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "社員向けの金融セミナーについてお話します。"
                break;
              case targetChildren[7].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "老後に向けた準備についてお話します。"
                break;
              case targetChildren[8].classList.contains("swiper-slide-active"):
                commentSP.innerHTML = "資産の継承についてお話します。"
                break;
              default:
                console.log('error');
            }


          }
          const obs = new MutationObserver(eachItems);
          obs.observe(target, options);
        }
      })
  }
}

class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-aco').click(function () {
      $(this).next('div').slideToggle();
      $(this).toggleClass('active');
    });
  }
}
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class Category {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      $('.js-category').click(function () {
        $(this).next('ul').slideToggle();
        // $(this).toggleClass('active');
      });
    } 
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
//noScroll
class HamburgerEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const hamBtn = document.querySelector(".js-hamTrigger")
    const hamContent = document.querySelector(".js-ham")
    const body = document.querySelector("body")

    hamBtn.addEventListener("click", () => {
      hamContent.classList.toggle("is-active")
      hamBtn.classList.toggle("is-open")
      body.classList.toggle("is-fixed")

    })

  }
}

//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    setTimeout(() => {
      $('.js-inview-load').addClass('is-inview');
    }, 300);

    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

//noScroll
class LoadingEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const loadingBar = document.querySelector(".loading-bar")

    loadingBar.classList.add("is-active")
    

  }
}

//noScroll
class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const interviewModalsTrigger = document.querySelectorAll(".js-interview-modalTrigger")
    const interviewModals = document.querySelectorAll(".js-interview-modal")
    const interviewModalsClose = document.querySelectorAll(".js-interview__modal-close")
    const body = document.querySelector("body")



    interviewModalsTrigger.forEach((modalTrigger, index) => {

      modalTrigger.addEventListener("click", () =>{
        if(index === 0){
          interviewModals[0].classList.add("is-active")
        }else if(index === 1){
          interviewModals[1].classList.add("is-active")
        }
        body.classList.add("is-fixed")
      })

      interviewModalsClose.forEach((closeBtn, index) => {
        closeBtn.addEventListener("click", () => {
          if(index === 0){
            interviewModals[0].classList.remove("is-active")
          }else if(index === 1){
            interviewModals[1].classList.remove("is-active")
          }
          body.classList.remove("is-fixed")
        })
      })



    })

    // interviewModalsClose.forEach((closeBtn, index) => {
    //   closeBtn.addEventListener("click", () =>{
    //     console.log("click");

    //     console.log(interviewModalsTrigger[0]);

    //     if(index === 0){
    //       interviewModalsTrigger[0].classList.remove("is-active")
    //     }else if(index === 1){
    //       interviewModalsTrigger[1].classList.remove("is-active")
    //     }
    //   })
    // })


  }
}

class MovieEvent {
  constructor(el, opt) {
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {
    const modalTrigger = document.querySelector(".r-content__movie");
    const modalContent = document.querySelector(".movieModal");
    const overlay = document.querySelector(".movieModal-overlay");
    const modalClose = document.querySelector(".movieModal__close");

    modalTrigger.addEventListener("click", () => {
      modalTrigger.classList.add("is-active")
      overlay.classList.add("is-active")
      modalContent.classList.add("is-active")
    })

    overlay.addEventListener("click", () => {
      modalTrigger.classList.remove("is-active")
      overlay.classList.remove("is-active")
      modalContent.classList.remove("is-active")
    })

    modalClose.addEventListener("click", () => {
      modalTrigger.classList.remove("is-active")
      overlay.classList.remove("is-active")
      modalContent.classList.remove("is-active")
    })
  }
}
//noScroll
class MvAnimation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const mvAnimation = () => {
      let tl = gsap.timeline({repeat: 0, repeatDelay: 1});

      if (window.matchMedia('(min-width: 768px)').matches) {
        tl.fromTo(".js-mv-fadeIn01", 0.5,
          {
            autoAlpha: 0,
            scale: 0.5,
            x: 100,

          }, {
            autoAlpha: 0.6,
            scale: 1.1,
            x: 100,
          }
        );
        tl.fromTo(".js-mv-fadeIn02", 0.7,
          {
            autoAlpha: 0,

          }, {
            autoAlpha: 1,
          },
          "<"
        );
        tl.fromTo(".js-mv-fadeIn01", 0.3,
          {
            x: 100,
            autoAlpha: 0.6,
            scale: 1.1,

          }, {
            x: 0,
            scale: 1,
            autoAlpha: 1,

          },


        );
        tl.fromTo(".js-mv-fadeIn03", 0.5,
          {
            autoAlpha: 0,

          }, {
            delay:0.5,
            autoAlpha: 1,
          }
        );
      }


      if (window.matchMedia('(max-width: 767px)').matches) {
        tl.fromTo(".js-mv-fadeIn01", 0.5,
        {
          autoAlpha: 0,
          scale: 0.5,
          x: 30,

        }, {
          autoAlpha: 0.6,
          scale: 1.1,
          x: 30,
        }
      );
      tl.fromTo(".js-mv-fadeIn02", 0.7,
        {
          autoAlpha: 0,

        }, {
          autoAlpha: 1,
        },
        "<"
      );
      tl.fromTo(".js-mv-fadeIn01", 0.3,
        {
          x: 30,
          autoAlpha: 0.6,
          scale: 1.1,

        }, {
          x: 0,
          scale: 1,
          autoAlpha: 1,

        },


      );
      tl.fromTo(".js-mv-fadeIn03", 0.5,
        {
          autoAlpha: 0,

        }, {
          delay:0.5,
          autoAlpha: 1,
        }
      );
      }




      }

    setTimeout(mvAnimation,600)


      function textAppear () {

        $(".js-mv-fadeIn02").css("opacity", 1)


        $('.strip').each(function(){
          var $t = $(this),
          rows = $.trim($t.html()).split('<br>');

          $t.html('');

          $.each(rows, function(i, val){
            $('<span class="row"></span>').appendTo($t);

            var letters = $.trim(val).split('');

            $.each(letters, function(j, v){
              v = (v == ' ') ? '&nbsp;' : v;
              $('<span class="textAnimation-item">' + $.trim(v) + '</span>').appendTo($('.row:last', $t));

            });

          });
        });

        for (let i = 0; i < $('.strip span').length; i++) {
          (function(ind) {
            setTimeout(function(){
                $('.strip span:not(".row")').eq(ind).addClass('animate');
            }, ind * 180);
          })(i);
        }

      }

  }
}

//noScroll
class NavFixed {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

  //   $(function () {
  //   // スクロールを開始したら
  //   $(window).on("scroll", function () {

  //     // ファーストビューの高さを取得
  //     let mvHeight = $(".js-mv").height() + 100;
  //     if ($(window).scrollTop() > mvHeight) {
  //       // スクロールの位置がファーストビューより下の場合にclassを付与
  //       $(".js-navFixed").addClass("is-fixed");
  //     }else {
  //       // スクロールの位置がファーストビューより上の場合にclassを外す
  //       $(".js-navFixed").removeClass("is-fixed");
  //     }

  //     if($(window).scrollTop()  > $(".l-footer").offset().top - 500){
  //       $(".js-navFixed").addClass("is-hidden");
  //     }else{
  //       $(".js-navFixed").removeClass("is-hidden");
  //     }
  //   });
  // });

  }

}

//noScroll
class SmoothScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    $(function(){
      // #で始まるa要素をクリックした場合に処理（"#"←ダブルクォーテンションで囲むのを忘れずに。忘れるとjQueryのバージョンによっては動かない。。）
      $('a[href^="#"]').click(function(){
        // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
        var adjust = -120;
        // スクロールの速度（ミリ秒）
        var speed = 400;
        // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
        var href= $(this).attr("href");
        // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
        var target = $(href == "#" || href == "" ? 'html' : href);
        // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
        var position = target.offset().top + adjust;
        // スムーススクロール linear（等速） or swing（変速）
        $('body,html').animate({scrollTop:position}, speed, 'swing');
        return false;
      });
    });

  }
}

//noScroll
class TabletAlert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    $(function(){
      if (window.matchMedia('(max-width: 830px) and (min-width:669px)').matches) {

        if( location.pathname === '/' ){

          let window_w = window.innerWidth;
          let window_h = window.innerHeight;
          const tabletAlertContent = document.querySelector(".js-tablet-alert")
          const closeBtn = document.querySelector(".js-tablet-close")

          if(window_w < window_h){
            const body = document.querySelector("body")
            const tabletAlert = document.querySelector(".js-tablet-alert")
            tabletAlert.classList.add("is-active")
            body.classList.add("is-fixed")
            closeBtn.addEventListener("click", () => {
            tabletAlertContent.classList.remove("is-active")
            })

          }
      }

    }})




  }
}

//noScroll
class TextAnimation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-strip').each(function(){
      var $t = $(this),
      rows = $.trim($t.html()).split('<br>');

      $t.html('');

      $.each(rows, function(i, val){
        $('<span class="row"></span>').appendTo($t);

        var letters = $.trim(val).split('');

        $.each(letters, function(j, v){
          v = (v == ' ') ? '&nbsp;' : v;
          $('<span class="textWord">' + $.trim(v) + '</span>').appendTo($('.row:last', $t));
        });

      });
    });



    //ターゲット要素をDOMで取得
    const target = document.querySelectorAll(".js-strip");
    target.forEach(el => {


      //オプション
      const options = {
        childList: true,
        characterData: true,
        characterDataOldValue: true,
        attributes: true,
        subtree: true,
      }

      //コールバック関数
      function callback(mutationsList, observer) {
        for(const mutation of mutationsList) {
            // 処理
            mutation.target //ターゲット要素
            mutation.addedNodes //追加されたDOM
            mutation.removedNodes //削除されたDOM

            const elWords = el.querySelectorAll(".textWord")

            let time = mutation.target.classList.contains('js-short') ? '30' : '50';

            for (let i = 0; i < elWords.length; i++) {
              (function(ind) {
                setTimeout(function(){
                  elWords[i].classList.add("animate")
                }, ind * time);
              })(i);
            }

        }
        //ターゲット要素の監視を停止
        obs.disconnect();
      }

      //インスタンス化
      const obs = new MutationObserver(callback);
      //ターゲット要素の監視を開始
      obs.observe(el, options);
    })







  }
}

//noScroll
class TopModal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    console.log("aa");

    /****************************
      モーダル表示
     ****************************/

    // モーダルを取得
    const modal = document.getElementById("modal");
    // モーダルを表示するボタンを全て取得
    const openModalBtns = document.querySelectorAll(".js-open-modal");
    // モーダルの中身
    const modalInners = document.querySelectorAll(".js-modal-inner");
    // モーダルを閉じるボタンを全て取得
    const closeModalBtns = document.querySelectorAll(".js-close-modal");
    // モーダル 前後
    const closeModalPrevNext = document.querySelectorAll(".js-modal-prev, .js-modal-next");
    
    // モーダルを表示するボタンをクリックしたとき
    openModalBtns.forEach((openModalBtn, index) => {
      openModalBtn.addEventListener("click", () => {
        let elIndex = index;
        if(openModalBtn.classList.contains('js-open-modal-sp')) {
          elIndex = index - modalInners.length;
        }
        modalInners[elIndex].classList.add("is-active");
        $('.js-modal-next, .js-modal-prev').css({'opacity': '1'});
        if(!modalInners[elIndex].nextElementSibling) {
          $('.js-modal-next').css({'opacity': '0'});
        }
        if(!modalInners[elIndex].previousElementSibling) {
          $('.js-modal-prev').css({'opacity': '0'});
        }
        console.log(modalInners[elIndex].nextElementSibling);
        console.log(modalInners[elIndex].previousElementSibling);
        modal.classList.add("is-active");
        body.classList.add("is-fixed")
      });
    });

    // モーダルを閉じるボタンをクリックしたとき
    closeModalBtns.forEach((closeModalBtn) => {
      closeModalBtn.addEventListener("click", () => {
        modalInners.forEach((modalInner) => {modalInner.classList.remove("is-active");})
        modal.classList.remove("is-active");
        body.classList.remove("is-fixed")
      });
    });

    // モダール 次へ・前へ
    closeModalPrevNext.forEach((_el) => {
      _el.addEventListener("click", (__el) => {
        let elIndex;
        modalInners.forEach((modalInner, index) => {
          if(modalInners[index].classList.contains("is-active")) {
            elIndex = __el.target.classList.contains('js-modal-next') ? index + 1 : index - 1;
            if(modalInners[elIndex]) {
              modalInners[index].classList.remove("is-active");
            }
          }
        })
        if(modalInners[elIndex]) {
          modalInners[elIndex].classList.add("is-active");
          if(!modalInners[elIndex].nextElementSibling) {
            $('.js-modal-next').css({'opacity': '0'});
          } else if(!modalInners[elIndex].previousElementSibling) {
            $('.js-modal-prev').css({'opacity': '0'});
          } else {
            $('.js-modal-next, .js-modal-prev').css({'opacity': '1'});
          }
        }
      });
    })

    const interviewModalsTrigger = document.querySelectorAll(".js-interview-modalTrigger")
    const interviewModals = document.querySelectorAll(".js-interview-modal")
    const interviewModalsClose = document.querySelectorAll(".js-interview__modal-close")
    const body = document.querySelector("body")



    interviewModalsTrigger.forEach((modalTrigger, index) => {

      modalTrigger.addEventListener("click", () =>{
        if(index === 0){
          interviewModals[0].classList.add("is-active")
        }else if(index === 1){
          interviewModals[1].classList.add("is-active")
        }
        body.classList.add("is-fixed")
      })

      interviewModalsClose.forEach((closeBtn, index) => {
        closeBtn.addEventListener("click", () => {
          if(index === 0){
            interviewModals[0].classList.remove("is-active")
          }else if(index === 1){
            interviewModals[1].classList.remove("is-active")
          }
          body.classList.remove("is-fixed")
        })
      })



    })

    // interviewModalsClose.forEach((closeBtn, index) => {
    //   closeBtn.addEventListener("click", () =>{
    //     console.log("click");

    //     console.log(interviewModalsTrigger[0]);

    //     if(index === 0){
    //       interviewModalsTrigger[0].classList.remove("is-active")
    //     }else if(index === 1){
    //       interviewModalsTrigger[1].classList.remove("is-active")
    //     }
    //   })
    // })


  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {
  window.scrollTo(0,0);

  let loadingEvent = new LoadingEvent('js-loading');
  let tabletAlert = new TabletAlert('js-tabletAlert');
  $(window).trigger('loading');

});

//after loading animation
$(window).on('loading', () => {
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let top = new Top('p-top');
  let member = new Member('p-member');
  let hamburgerEvent = new HamburgerEvent('js-ham');
  let smoothScroll = new SmoothScroll('js-smoothScroll');
  let accordion = new Accordion('js-aco');
  let modal = new Modal('js-modal');
  let topModal = new TopModal('js-open-modal');
  let category = new Category('js-category');
  let textAnimation = new TextAnimation('js-textAnimation');
  let mvAnimation = new MvAnimation('js-mvAnimation');
  let navFixed = new NavFixed('js-navFixed');
  let movieEvent = new MovieEvent('movieModal');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });